import { ReactNode } from 'react';

export enum NotificationType {
  Info = 'info',
  Success = 'success',
  Warning = 'warning',
  GameConnectionError = 'game-connection-error',
  RequestTimeout = 'request-timeout',
  Error = 'error',
}

export interface NotificationBase {
  id: string;
  type: NotificationType;
  message: ReactNode;
  details?: ReactNode;
}

export interface NotificationInfo extends NotificationBase {
  type: NotificationType.Info;
}

export interface NotificationSuccess extends NotificationBase {
  type: NotificationType.Success;
}

export interface NotificationWarning extends NotificationBase {
  type: NotificationType.Warning;
}

export interface NotificationError extends NotificationBase {
  type: NotificationType.Error;
  error?: Error;
}

export interface NotificationGameConnectivityError extends NotificationBase {
  type: NotificationType.GameConnectionError;
  error?: Error;
}

export interface NotificationRequestTimeout extends NotificationBase {
  type: NotificationType.RequestTimeout;
  error?: Error;
}

export type Notification =
  | NotificationInfo
  | NotificationSuccess
  | NotificationWarning
  | NotificationGameConnectivityError
  | NotificationRequestTimeout
  | NotificationError;
